import React, { useState } from 'react';
import styles from './ToolTip.module.css';
import classNames from 'classnames';

const Tooltip = ({ children, content, mode="dark", size="sm" }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className={styles.tooltipWrapper}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
      tabIndex={0}
    >
      {children}
      {visible && (
        <div className={classNames(styles.tooltipBox, styles[mode], styles[size])} role="tooltip">
          {content}
          <span className={styles.tooltipArrow} />
        </div>
      )}
    </div>
  );
};

export default Tooltip;
